var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FixedSizeList } from "react-window";
export default React.forwardRef((_a, ref) => {
    var { getItemKey } = _a, fixedListProps = __rest(_a, ["getItemKey"]);
    return (React.createElement(FixedSizeList, Object.assign({ ref: ref, itemKey: (index, data) => {
            const key = (typeof data === "object" && getItemKey && getItemKey(data)) ||
                index;
            if (data == null || key == null)
                return index;
            return key;
        } }, fixedListProps)));
});
//# sourceMappingURL=FixedSizeList.js.map